import React from 'react';
import Markdown from 'marked-react';
import { Link, useParams } from 'react-router-dom';
import { OptimizedImage } from '../components/site/OptimizedImage';
import { Seo } from '../components/site/Seo';
import { useContentfulCollection } from '../hooks/useContentfulCollection';
import { LATEST_SECTION_HREF } from '../lib/siteRoutes';
import { NotFoundPage } from './NotFoundPage';

function formatArticleDate(value) {
  if (!value) {
    return '';
  }

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return '';
  }

  return parsedDate.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function ResourceDetailPage() {
  const { slug } = useParams();
  const { items: articles, isLoading } = useContentfulCollection('resourceArticles', { pageSize: 100 });
  const article = articles.find((item) => item.slug === slug);
  const articleDate = formatArticleDate(article?.publishedAt);

  if (!article && isLoading) {
    return <div className='page-shell loading-shell'>Loading article…</div>;
  }

  if (!article) {
    return <NotFoundPage />;
  }

  return (
    <>
      <Seo
        title={`${article.title} | Resources | Rivelin Robotics`}
        description={article.summary}
        image={article.featuredImage}
      />
      <article className='detail-shell'>
        <Link className='inline-link back-link' to={LATEST_SECTION_HREF}>
          ← Back to latest
        </Link>
        <p className='section-label'>{[article.category, articleDate].filter(Boolean).join(' · ')}</p>
        <h1 className='detail-title'>{article.title}</h1>
        <p className='detail-summary'>{article.summary}</p>
        {article.featuredImage ? <img src={article.featuredImage} alt={article.title} className='detail-hero-image' loading='lazy' decoding='async' /> : null}
        <div className='detail-body markdown-body'>
          <Markdown>{article.body}</Markdown>
        </div>
      </article>
    </>
  );
}
